<div class="toolbarSearch toolbarSection push-right" *ngIf="!hide">
    <div class="toolbarDivider"></div>
    <acl-ngx-input [formControl]="searchProps.searchString" [compact]="searchProps.compact"
        [variant]="searchProps.variant" [leftElement]="searchProps.leftElement" [placeholder]="searchProps.placeholder"
        [fluid]="searchProps.fluid" [showRightElement]="searchProps.showRightElement"
        (keyup)="handleOnSearchTextChange($event)">
        <acl-ngx-button [variant]="searchProps.rightElement.variant"
            [ultraCompact]="searchProps.rightElement.ultraCompact" [icon]="searchProps.rightElement.icon"
            (click)="handleOnRemoveSearchText($event)"></acl-ngx-button>
    </acl-ngx-input>
</div>